"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M12 3c-4.9704 0-9 4.0263-9 8.9926 0 3.8117 2.3704 7.0683 5.7185 8.3783-.0815-.7105-.1481-1.8059.0297-2.5831.163-.7031 1.0518-4.4704 1.0518-4.4704s-.2667-.5403-.2667-1.3322c0-1.2508.726-2.1834 1.6297-2.1834.7703 0 1.1407.5773 1.1407 1.2656 0 .7698-.4889 1.9244-.7481 2.9976-.2149.8955.4518 1.6283 1.3333 1.6283 1.6 0 2.8296-1.6875 2.8296-4.1152 0-2.1538-1.5481-3.6562-3.7629-3.6562-2.563 0-4.0667 1.917-4.0667 3.9005 0 .7697.2963 1.5987.6667 2.0501.074.0888.0814.1703.0592.2591-.0667.2812-.2222.8955-.2518 1.0214-.037.1628-.1334.1998-.3037.1184-1.126-.5255-1.8297-2.1612-1.8297-3.486 0-2.8347 2.0593-5.44 5.9482-5.44 3.1185 0 5.5481 2.2204 5.5481 5.1957 0 3.1012-1.9555 5.5954-4.6666 5.5954-.9112 0-1.7704-.4737-2.0593-1.0362l-.563 2.139c-.2.7845-.7481 1.7615-1.1185 2.361A9.0452 9.0452 0 0 0 11.9852 21c4.9704 0 9-4.0263 9-8.9926C21 7.0264 16.9704 3 12 3z"
  })];
};

exports.default = _default;